import React, { useState, useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { FaDownload, FaQrcode } from 'react-icons/fa';

const Qrcode = () => {
    const [text, setText] = useState('');
    const qrCodeRef = useRef(null);

    const handleDownload = () => {
        if (!qrCodeRef.current) return;

        const canvas = qrCodeRef.current;
        const link = document.createElement('a');
        link.download = `alwaseeq-qr-${Date.now()}.png`;
        link.href = canvas.toDataURL('image/png');
        link.click();
    };

    return (
        <div className="auth-container d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', paddingTop: '100px', paddingBottom: '100px' }}>
            <div className="auth-card p-4 p-md-5" style={{ maxWidth: '500px', width: '100%' }}>
                <div className="text-center mb-5">
                    <div className="mb-3" style={{ color: 'var(--secondary-color)', fontSize: '2.5rem' }}>
                        <FaQrcode />
                    </div>
                    <h2 className="section-head-main mb-2" style={{ fontSize: '1.8rem' }}>QR GENERATOR</h2>
                    <div style={{ width: '40px', height: '2px', backgroundColor: 'var(--secondary-color)', margin: '0 auto' }}></div>
                </div>

                <div className="mb-4">
                    <label className="section-index mb-2" style={{ fontSize: '0.7rem' }}>ENTER CONTENT</label>
                    <input
                        type="text"
                        className="auth-input w-100"
                        placeholder="URL or Text message..."
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        style={{ background: 'rgba(255,255,255,0.03)' }}
                    />
                </div>

                {text ? (
                    <div className="text-center animate-fade-in">
                        <div className="qr-preview-container mb-4">
                            <QRCodeCanvas
                                ref={qrCodeRef}
                                value={text}
                                size={220}
                                level="H"
                                includeMargin={true}
                                bgColor="#ffffff"
                                fgColor="#000000"
                            />
                        </div>

                        <button
                            onClick={handleDownload}
                            className="btn-book-now w-100 py-3 d-flex align-items-center justify-content-center gap-2"
                        >
                            <FaDownload /> DOWNLOAD QR CODE
                        </button>
                    </div>
                ) : (
                    <div className="text-center py-5 border border-dashed border-secondary-dim rounded" style={{ opacity: 0.3 }}>
                        <p className="m-0 small letter-spacing-2">AWAITING INPUT...</p>
                    </div>
                )}
            </div>

            <style>{`
                .qr-preview-container {
                    background: #fff;
                    padding: 15px;
                    display: inline-block;
                    border-radius: 8px;
                    box-shadow: 0 10px 30px rgba(0,0,0,0.3);
                }

                .animate-fade-in {
                    animation: fadeIn 0.5s ease-out forwards;
                }

                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }

                .border-dashed {
                    border-style: dashed !important;
                    border-width: 1px !important;
                    border-color: rgba(255,255,255,0.1) !important;
                }
            `}</style>
        </div>
    );
};

export default Qrcode;
